<div uiactionstrip>
  <btn
    class="tertiary"
    [settings]="{
      icon: ICONS.CHEVRON_LEFT,
      disabled: currentPage() <= 1,
      tag: 'PDF Viewer Previous',
    }"
    (click)="prevPage()"
  >
  </btn>

  <label
    class="text-size-input-label text-input-label font-medium dark:text-input-label-dark"
    [label]="`${currentPage()} / ${totalPages()}`"
  ></label>

  <btn
    class="tertiary"
    [settings]="{
      icon: ICONS.CHEVRON_RIGHT,
      disabled: currentPage() >= totalPages(),
      tag: 'PDF Viewer Next',
    }"
    (click)="nextPage()"
  >
  </btn>

  <btn
    class="tertiary ml-auto"
    [settings]="{
      label: '-',
      disabled: currentScale() <= 0.5,
      tag: 'PDF Viewer Zoom Out',
    }"
    (click)="zoomOut()"
  >
  </btn>

  <label
    class="text-size-input-label text-input-label font-medium dark:text-input-label-dark"
    [label]="scaleLabel()"
  ></label>

  <btn
    class="tertiary"
    [settings]="{
      label: '+',
      disabled: currentScale() >= 3,
      tag: 'PDF Viewer Zoom In',
    }"
    (click)="zoomIn()"
  >
  </btn>
</div>

<div uipdfviewercanvas [uiloading]="'PDF File'">
  <canvas #pdfCanvas></canvas>
</div>
